import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../types/interfaces';

type TBannerAction = 'show_sopr' | 'click';

const page = {
  pageType: 'ListingJK',
  listingType: 'list',
  siteType: 'desktop',
} as const;

export function trackBannerShow(jsonQuery: IJsonQuery): void {
  trackBannerEvent(jsonQuery, 'show_sopr');
}

export function trackBannerClick(jsonQuery: IJsonQuery): void {
  trackBannerEvent(jsonQuery, 'click');
}

function trackBannerEvent(jsonQuery: IJsonQuery, action: TBannerAction): void {
  ca('eventSite', {
    name: 'oldevent',
    action,
    category: 'banner',
    label: 'MortgageRateHikeListing',
    sc: jsonQuery,
    page,
  });
}
